import { render, staticRenderFns } from "./p295_blog_main.vue?vue&type=template&id=038925c4"
import script from "./p295_blog_main.vue?vue&type=script&lang=js"
export * from "./p295_blog_main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementBuilder: require('/root/containers/hermes_eshop/components/core/elementBuilder.vue').default,P295ArticleCard: require('/root/containers/hermes_eshop/components/hyper/p295/p295_article_card.vue').default})
